var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_748_225",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 9,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1466 15.1454C3.9515 15.3408 3.95139 15.6577 4.14636 15.8533C4.34132 16.0488 4.65753 16.0489 4.85263 15.8535L12.2687 8.42552C12.2989 8.40621 12.3275 8.38334 12.3539 8.35688C12.5449 8.1653 12.5486 7.85726 12.365 7.66121C12.3588 7.65424 12.3523 7.64741 12.3457 7.64072C12.3399 7.63495 12.3341 7.62935 12.3281 7.62393L4.85269 0.146342C4.65747 -0.0489431 4.34113 -0.0487562 4.14613 0.146757C3.95113 0.34227 3.95131 0.659073 4.14654 0.854357L11.2853 7.99517L4.1466 15.1454Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_748_225)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightOutlined);
export default __webpack_public_path__ + "static/media/chevron-right-outlined.5e4af43a62b6b8aaf0669db72fcf3421.svg";
export { ForwardRef as ReactComponent };